import { render, staticRenderFns } from "./GuidPocket.vue?vue&type=template&id=647f8e29&scoped=true&"
import script from "./GuidPocket.vue?vue&type=script&lang=js&"
export * from "./GuidPocket.vue?vue&type=script&lang=js&"
import style0 from "./GuidPocket.vue?vue&type=style&index=0&id=647f8e29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f8e29",
  null
  
)

export default component.exports